/**
 * Cómo se entra, según el entorno. UN SOLO SITIO para las variables de la
 * autenticación y sus tiempos.
 *
 * Todas se hornean al compilar, como `VITE_API_URL` (§12): cambiar el SSO de
 * un despliegue es un build nuevo.
 */

/**
 * Se entra siempre por el SSO de lala-ms (§10.3), también en desarrollo.
 *
 * Donde vive el servicio `auth` de lala-ms: `/api/auth/sso/*` cuelga de aquí. */
export const AUTH_BASE_URL: string = (
  import.meta.env.VITE_AUTH_BASE_URL ?? ""
).replace(/\/+$/, "");

/**
 * A dónde vuelve el SSO con el `code`. FIJO por entorno, nunca calculado de la
 * página: si el de `authorize` y el que el API usa al canjear no coinciden
 * letra por letra, el canje falla sin decir por qué (lección 8 de
 * `lala-ms/home-ui/docs/SSO.md`).
 */
export const AUTH_REDIRECT_URI: string =
  import.meta.env.VITE_AUTH_REDIRECT_URI ?? "";

/** La ruta de la SPA que recibe al usuario de vuelta del SSO. */
export const AUTH_CALLBACK_PATH = "/auth/callback";

/**
 * Cuánto vale el intento de login guardado --verifier, state y a dónde
 * volver--. Lo que el `code` dura en el servidor (5 min) y un margen para
 * quien escribe su contraseña despacio.
 */
export const SIGN_IN_ATTEMPT_TTL_MS = 10 * 60_000;

/**
 * El anti-bucle: tras lanzar el SSO solo, durante este tiempo no se vuelve a
 * lanzar solo. Si en ese rato se pierde otra vez la sesión, se enseña una
 * pantalla de error con un botón, en vez de rebotar contra el SSO sin fin.
 */
export const AUTO_SIGN_IN_COOLDOWN_MS = 60_000;

/** Lo que falta para poder entrar, o `null` si no falta nada. */
export const missingAuthConfig = (): string | null => {
  if (AUTH_BASE_URL === "") return "VITE_AUTH_BASE_URL";
  if (AUTH_REDIRECT_URI === "") return "VITE_AUTH_REDIRECT_URI";
  return null;
};
